// Uninstall an app from a modular smart account (space / user) via AppInstallerFacet.
export async function uninstallApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { target, appAddress, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for uninstallApp operation.');
    }
    const targetAddress = target === 'space' ? fnArgs.spaceAddress : fnArgs.userAddress;
    const onAppUninstallCallData = new Uint8Array(0);
    const toUninstallAppCallData = appRegistryDapp.installer.interface.encodeFunctionData('uninstallApp', [appAddress, targetAddress, onAppUninstallCallData]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.installer.address],
        callData: [toUninstallAppCallData],
        signer,
        spaceId: target === 'space' ? fnArgs.spaceAddress : undefined,
        functionHashForPaymasterProxy: 'uninstallApp',
    });
}
